import api from "./apiMethods";

const { REACT_APP_API_URL } = process.env;

export const login = (payload) => {
  const request = {
    method: "POST",
    data: payload,
    body: JSON.stringify(payload),
    url: `${REACT_APP_API_URL}/auth/login`,
    headers: {
      "content-type": "application/json",
    },
  };

  return api(request);
};
